<template>
  <a-layout-sider :width="width" class="pr-layout-sider" theme="light">
    <!-- {{ sider }} -->
    <template v-if="sider === 'user'">
      <div class="sider-avator"><img :src="defaultAator" /></div>
      <div class="user-info" v-if="username">
        <div class="info-key">{{ $t('user.Name') }}:</div>
        <div class="info-value">{{ username }}</div>
      </div>
      <div class="user-info" v-if="getRoleName(role)">
        <div class="info-key">{{ $t('user.Role') }}:</div>
        <div class="info-value">{{ getRoleName(role) }}</div>
      </div>
      <div class="user-info" v-if="brand">
        <div class="info-key">{{ $t('user.Brand') }}:</div>
        <div class="info-value">{{ brand }}</div>
      </div>
      <div class="user-info" v-if="userTitle">
        <div class="info-key">{{ $t('user.Title') }}:</div>
        <div class="info-value">{{ userTitle }}</div>
      </div>
      <div class="user-info" v-if="lineManager">
        <div class="info-key">{{ $t('user.Review Manager') }}:</div>
        <div class="info-value">{{ lineManager }}</div>
      </div>
      <div class="user-info" v-if="hrbp">
        <div class="info-key">{{ $t('user.HRBP') }}:</div>
        <div class="info-value">{{ hrbp }}</div>
      </div>
    </template>
    <template v-else-if="sider === 'guide'">
      <div class="sider-avator"><img :src="avator || defaultAator" /></div>
      <div class="user-info" v-if="username">
        <div class="info-key">{{ $t('user.Name') }}:</div>
        <div class="info-value">{{ username }}</div>
      </div>
      <div class="user-info" v-if="getRoleName(role)">
        <div class="info-key">{{ $t('user.Role') }}:</div>
        <div class="info-value">{{ getRoleName(role) }}</div>
      </div>
      <div class="user-info" v-if="brand">
        <div class="info-key">{{ $t('user.Brand') }}:</div>
        <div class="info-value">{{ brand }}</div>
      </div>
      <div class="user-info" v-if="userTitle">
        <div class="info-key">{{ $t('user.Title') }}:</div>
        <div class="info-value">{{ userTitle }}</div>
      </div>
      <div class="user-info" v-if="lineManager">
        <div class="info-key">{{ $t('user.Review Manager') }}:</div>
        <div class="info-value">{{ lineManager }}</div>
      </div>
      <div class="user-info" v-if="hrbp">
        <div class="info-key">{{ $t('user.HRBP') }}:</div>
        <div class="info-value">{{ hrbp }}</div>
      </div>
    </template>
    <template v-else-if="sider === 'me/apply'">
      <div class="sider-avator"><img :src="avator || defaultAator" /></div>
      <div class="step-tips-panel">
        <div class="step-tips-item">
          <div class="step-tips-icon">1</div>
          <div class="step-tips-text">
            {{ $t('user.Select your current role') }}
          </div>
        </div>
        <div class="step-tips-separator">
          <down-outlined />
        </div>
        <div class="step-tips-item">
          <div class="step-tips-icon">2</div>
          <div class="step-tips-text">
            {{ $t('user.Check job qualifications and leave comments') }}
          </div>
        </div>
        <div class="step-tips-separator">
          <down-outlined />
        </div>
        <div class="step-tips-item">
          <div class="step-tips-icon">3</div>
          <div class="step-tips-text">
            {{ $t('user.Proceed to next step') }}
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="sider === 'me/apply/target'">
      <div class="sider-avator"><img :src="avator || defaultAator" /></div>
      <div class="step-tips-panel">
        <div class="step-tips-item">
          <div class="step-tips-icon">1</div>
          <div class="step-tips-text">
            {{ $t('user.Select your target role') }}
          </div>
        </div>
        <div class="step-tips-separator">
          <down-outlined />
        </div>
        <div class="step-tips-item">
          <div class="step-tips-icon">2</div>
          <div class="step-tips-text">
            {{
              $t(
                'user.Review job qualification as reference for your future development'
              )
            }}
          </div>
        </div>
        <div class="step-tips-separator">
          <down-outlined />
        </div>
        <div class="step-tips-item">
          <div class="step-tips-icon">3</div>
          <div class="step-tips-text">
            {{ $t('user.Submit the application') }}
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="sider === 'teams/details'">
      <div class="step-tips-panel">
        <div class="step-tips-item">
          <div class="step-tips-icon">1</div>
          <div class="step-tips-text">
            {{ $t('user.View assessment and comments from your employee') }}
          </div>
        </div>
        <div class="step-tips-separator">
          <down-outlined />
        </div>
        <div class="step-tips-item">
          <div class="step-tips-icon">2</div>
          <div class="step-tips-text">
            {{
              $t(
                "user.Assess your employee's qualification of his/her current role"
              )
            }}
          </div>
        </div>
        <div class="step-tips-separator">
          <down-outlined />
        </div>
        <div class="step-tips-item">
          <div class="step-tips-icon">3</div>
          <div class="step-tips-text">
            {{ $t('user.Submit the assessment') }}
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="sider === 'teams/list'">
      <div class="sider-avator"><img :src="defaultAator" /></div>
      <div class="step-tips-text">
        {{
          $t(
            'user.Check the status of your team members’ applications. Review and evaluate the applications of your team members.'
          )
        }}
      </div>
    </template>
    <template v-else-if="sider === 'me/list'">
      <div class="sider-avator"><img :src="defaultAator" /></div>
      <div class="step-tips-text">
        {{ $t('user.Check the status of your application') }}
      </div>
    </template>
    <template v-else-if="sider === 'group/list'">
      <div class="step-tips-panel">
        <div class="step-tips-item">
          <div class="step-tips-icon">1</div>
          <div class="step-tips-text">
            {{ $t('user.Review the application status') }}
          </div>
        </div>
        <div class="step-tips-separator">
          <down-outlined />
        </div>
        <div class="step-tips-item">
          <div class="step-tips-icon">2</div>
          <div class="step-tips-text">
            {{ $t('user.View the details if needed') }}
          </div>
        </div>
        <div class="step-tips-separator">
          <down-outlined />
        </div>
        <div class="step-tips-item">
          <div class="step-tips-icon">3</div>
          <div class="step-tips-text">
            {{
              $t(
                'user.If the application does not meet the requirements, please reopen'
              )
            }}
          </div>
        </div>
        <div class="step-tips-separator">
          <down-outlined />
        </div>
        <div class="step-tips-item">
          <div class="step-tips-icon">4</div>
          <div class="step-tips-text">
            {{
              $t(
                'user.Ensure that all status have been reviewed by the review manager'
              )
            }}
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="sider === 'group/details'">
      <div class="sider-avator"><img :src="defaultAator" /></div>
      <div class="step-tips-text">
        {{
          $t(
            'user.View assesement from employee and review manager. Panel result and comments will also be displayed here after you upload the data.'
          )
        }}
      </div>
    </template>
    <template v-else-if="sider === 'group/details/2'">
      <div class="sider-avator"><img :src="defaultAator" /></div>
      <div class="step-tips-text">
        {{
          $t(
            'user.View assesement from employee and review manager. Panel result and comments will also be displayed here after you upload the data.'
          )
        }}
      </div>
    </template>
  </a-layout-sider>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import defaultAator from '@/assets/default-role-avator.png'
  import { DownOutlined } from '@ant-design/icons-vue'

  export default {
    name: 'PrSider',
    components: { DownOutlined },
    props: {
      width: {
        type: Number,
        default: 208,
      },
    },
    data() {
      return {
        defaultAator,
        // model: 'user', // apply
        avatorDic: {},
      }
    },
    computed: {
      ...mapGetters({
        sider: 'routes/sider',
        role: 'acl/role',
        username: 'user/username',
        avator: 'user/avator',
        brand: 'user/brand',
        userTitle: 'user/title',
        lineManager: 'user/lineManager',
        hrbp: 'user/hrbp',
      }),
    },
    watch: {},
    methods: {
      getRoleName(roles) {
        const rolekey = roles[roles.length - 1]
        if (rolekey === 'c') {
          return 'HRBP'
        } else {
          return null
        }
      },
    },
  }
</script>

<style lang="less">
  @import url('@/styles/params.less');

  .pr-layout-sider {
    box-shadow: 2px 0px 6px 0px rgba(31, 31, 31, 0.12);
    padding: 32px 16px;
    text-align: center;
    z-index: 9;
    .sider-avator {
      width: 176px;
      margin: 0 auto 30px auto;

      img {
        width: 100%;
      }
    }
    .user-info {
      max-width: 120px;
      margin: 16px auto;
      text-align: left;
      font-size: 14px;
      .info-key {
        color: #666666;
        line-height: 22px;
        margin-bottom: 4px;
      }
      .info-value {
        font-weight: bold;
        color: #333333;
        line-height: 22px;
      }
    }
  }
  .step-tips-panel {
    .step-tips-item {
      text-align: center;
    }
    .step-tips-icon {
      width: 32px;
      height: 32px;
      line-height: 30px;
      border: 1px solid @primary-color;
      border-radius: 100%;
      color: @primary-color;
      margin: 12px auto 16px auto;
    }
    .step-tips-text {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      line-height: 22px;
      margin: 12px auto;
    }
  }
</style>
